import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    currentTab: null,
  },
  getters: {
    currentTab: (state) => {
      return state.currentTab;
    },
  },
  mutations: {
    SAVE_CURRENT_TAB(state, payload) {
      state.currentTab = payload;
    },
  },
  actions: {
    setCurrentTab({ commit }, payload) {
      commit("SAVE_CURRENT_TAB", payload);
    },
  },
};
